const subscriptiontablerecallcolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "recallName",
    label: "Recall Name",
  },
  {
    key: "price",
    label: "Price",
  },
  {
    key: "duration",
    label: "Duration",
  },
  {
    key: "durationMode",
    label: "Duration Mode",
  },
  {
    key: "reSubscriptionPrice",
    label: "Resubscription Price",
  },
  {
    key: "isTrial",
    label: "Trial",
  },
  {
    key: "isLive",
    label: "Status",
  },
  {
    key: "actions",
    label: "Actions",
  },
];

export { subscriptiontablerecallcolumn };
